import * as React from 'react'
import { removeLocalStorageItem } from '../../../util/LocalStorage';
import { LOCAL_STORAGE_LOGGED_USER } from '../../../constants';

interface Props {
  logout: () => void;
  onComplete: () => void
}
export class CallLogout extends React.PureComponent<Props> {
  async componentDidMount() {
    await this.props.logout();
		removeLocalStorageItem(LOCAL_STORAGE_LOGGED_USER);
    this.props.onComplete();
  }
  render() {
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/modules/auth/logout/CallLogout.tsx